import { API_ROOT } from '../../constants';

export const NAME = 'checkout';

export const PAY_URL = `${API_ROOT}/payment-solution/checkout-flow/pay`;

// Order state
export const PENDING = 'PENDING';
export const VALIDATED = 'VALIDATED';
export const CANCELED = 'CANCELED';
export const INSUFFICIENT_FOUND = 'INSUFFICIENT_FOUND';
export const WAITING_TRANSACTION = 'WAITING_TRANSACTION';
export const WAITING_STOCK = 'WAITING_STOCK';

export const REQUEST_CHECKOUT_PAY = 'REQUEST_CHECKOUT_PAY';
export const SUCCESS_CHECKOUT_PAY = 'SUCCESS_CHECKOUT_PAY';
export const FAILURE_CHECKOUT_PAY = 'FAILURE_CHECKOUT_PAY';

export const REQUEST_CHECKOUT_DETAILS = 'REQUEST_CHECKOUT_DETAILS';
export const SUCCESS_CHECKOUT_DETAILS = 'SUCCESS_CHECKOUT_DETAILS';
export const FAILURE_CHECKOUT_DETAILS = 'FAILURE_CHECKOUT_DETAILS';

// Error codes
export const DECLINED_PAYMENT_CODE = '406';



// WEBPACK FOOTER //
// ./src/services/checkout/constants.js